import { formatDate } from "helpers/common_helpers";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  cancelSubscription,
  getAllPlans,
  myCurrentSubscription,
} from "store/actions/subscriptionSlice";
import classNames from "classnames";
import {
  CurrencySymbol,
  formatPlanType,
  getMinMaxDate,
} from "components/common/Utils";
import { useNavigate } from "react-router-dom";
import { showAlert } from "store/reducers/alertReducer";
import planBenefitimg from "../../../assets/images/icons/checked.svg";
import { getCompanyInfo } from "store/actions/authSlice";
import { Modal } from "react-bootstrap";
import tick from "assets/images/icons/tick.svg";
import customPlan from "assets/images/icons/customPlan.svg";
import checkGreen from "assets/images/icons/check.svg";
import checkWhite from "assets/images/icons/checkWhite.svg";
import fee1 from "assets/images/icons/fee1.svg";
import fee2 from "assets/images/icons/fee2.svg";
import fee3 from "assets/images/icons/fee3.svg";
import fee4 from "assets/images/icons/fee4.svg";
import planStar from "assets/images/icons/planStar.svg";
import circle from "assets/images/icons/cancel.svg";
import { ChevronLeft } from "lucide-react";
import PlanUpgrade from "./PlanUpgrade/PlanUpgrade";

function MyPlanInfo() {
  const { t, i18n } = useTranslation();
  const { isLoading, allPlans, mySubscriptionDetails } = useSelector(
    (state) => state.Subscriptions
  );
  const { brandInfo } = useSelector((state) => state.auth);

  const [planType, setPlanType] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [nonEnterpricePlan, setNonEnterpricePlan] = useState(null);
  const [billingCycle, setBillingCycle] = useState("yearly");
  const [subTotal, setSubTotal] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [isCancelled, setIsCancelled] = useState(false);
  const [show2, setShow2] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [show, setShow] = useState(false);
  const [continueBtn, setContinueBtn] = useState(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleOpen = () => setShowModal(true);
  const handleHideModal2 = () => setShow2(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleCancelSubscription = () => {
    dispatch(cancelSubscription())
      .then((action) => {
        const { statusCode, success, message } = action?.payload;
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }));
          dispatch(getCompanyInfo());
          dispatch(myCurrentSubscription());
          setIsCancelled(true);
        } else {
          dispatch(showAlert({ text: message, type: "error" }));
        }
      })
      .catch((err) => {});
  };

  const handleUpdatePlan = () => {
    const { isTrial, planId } = mySubscriptionDetails || {};
    if (isTrial) {
      navigate(`/subscription?selectedPlan=${selectedPlan?.name}`);
    } else {
      handleShow(true);
    }
  };

  useEffect(() => {
    dispatch(getAllPlans());
  }, [dispatch]);

  // Update nonEnterpricePlan and billingCycle when allPlans or mySubscriptionDetails change
  useEffect(() => {
    const starterPlan = allPlans?.find(
      (p) => p.billingCycle === "monthly" && !p.isCustom
    );
    const professionalPlan = allPlans?.find(
      (p) => p.billingCycle === "yearly" && !p.isCustom
    );

    if (mySubscriptionDetails?.planId?.name === "Professional") {
      setBillingCycle("yearly");
      setNonEnterpricePlan(professionalPlan);
      setSelectedPlan(professionalPlan);
      setPlanType(professionalPlan?.name || "");
    } else {
      setBillingCycle("monthly");
      setNonEnterpricePlan(starterPlan);
      setSelectedPlan(starterPlan);
      setPlanType(starterPlan?.name || "");
    }
  }, [allPlans, mySubscriptionDetails]);

  // Update subTotal, discountAmount, and totalAmount when selectedPlan changes
  useEffect(() => {
    if (selectedPlan && !selectedPlan.isCustom) {
      setSubTotal(selectedPlan.discountedPrice || 0);
      setDiscountAmount(
        (selectedPlan.price || 0) - (selectedPlan.discountedPrice || 0)
      );
      setTotalAmount(getMonthlyPrice(selectedPlan));
      setContinueBtn(false);
    } else {
      setSubTotal(0);
      setDiscountAmount(0);
      setTotalAmount(0);
      setContinueBtn(true);
    }
  }, [selectedPlan]);

  // Get Individual plans
  const starterPlan = allPlans?.find(
    (p) => p.billingCycle === "monthly" && !p.isCustom
  );
  const professionalPlan = allPlans?.find(
    (p) => p.billingCycle === "yearly" && !p.isCustom
  );
  const enterprisePlan = allPlans?.find((p) => p.isCustom);

  const isProfessionalPlan =
    mySubscriptionDetails?.planId?.name === "Professional";

  const getMonthlyPrice = (plan) => {
    if (!plan?.discountedPrice) return 0;
    return plan?.billingCycle === "yearly"
      ? (plan.discountedPrice / 12).toFixed(2)
      : plan.discountedPrice;
  };

  const getBasePrice = (plan) => {
    if (!plan?.price) return 0;
    return plan?.billingCycle === "yearly"
      ? (plan.price / 12).toFixed(2)
      : plan.price;
  };

  const getYearlyPrice = (plan) => {
    if (!plan?.price) return 0;
    return plan.billingCycle === "monthly"
      ? (plan.price * 12).toFixed(2)
      : plan.price;
  };

  const handleButtonClick = (plan) => {
    setNonEnterpricePlan(plan);
    setBillingCycle(plan.billingCycle);
    setSelectedPlan(plan);
    setPlanType(plan.name);
    // Do not open modal immediately; let the card update
  };
  const activePlan =
    nonEnterpricePlan?.billingCycle === "yearly"
      ? professionalPlan
      : starterPlan;

      console.log("myCurrentSubscription" , mySubscriptionDetails)
      

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="common_card_2 mt-0">
          {/* Plan Info Section */}
          <div className="g_between gap-3 align-items-start flex-wrap">
            <div className="plan_div align-items-start">
              <div className="box"></div>
              <div>
                <h2 className="fs_12 text_dark_gray">{t("Plan")}</h2>
                <h2 className="fs_20 text_black text-capitalize">
                  {mySubscriptionDetails.cancelledInfo?.isCancelled
                    ? t("No Active Plan")
                    : mySubscriptionDetails.isTrial
                    ? "Free trial"
                    : mySubscriptionDetails.billingCycle}
                  {mySubscriptionDetails.cancelledInfo?.isCancelled && (
                    <h6 className="cancelled_text fs_14 text_danger">
                      Cancelled
                      {mySubscriptionDetails?.status !== 3 &&
                        `- active until ${formatDate(
                          mySubscriptionDetails?.billingCycleEnd
                        )}`}
                    </h6>
                  )}
                </h2>
              </div>
            </div>
            <div className="cancel_subscription_plan">
              {!mySubscriptionDetails.cancelledInfo?.isCancelled &&
                !mySubscriptionDetails?.isTrial && (
                  <button
                    onClick={() => setShow2(true)}
                    disabled={isLoading}
                    className="cancel_btn_2 d-block ms-auto"
                  >
                    {t("Cancel Subscription")}
                  </button>
                )}
            </div>
          </div>
          <div className="plan_details">
            <div className="single_details">
              <h2 className="fs_12 text_dark_gray">{t("Due On")}</h2>
              <h2 className="fs_14 text_black_3">
                {formatDate(mySubscriptionDetails?.trialEndDate)}
              </h2>
            </div>
            <div className="single_details">
              <h2 className="fs_12 text_dark_gray">{t("Locations")}</h2>
              <h2 className="fs_14 text_black_3">
                {mySubscriptionDetails?.features?.locations}
              </h2>
            </div>
            <div className="single_details">
              <h2 className="fs_12 text_dark_gray">{t("Members")}</h2>
              <h2 className="fs_14 text_black_3">
                {mySubscriptionDetails?.features?.members}
              </h2>
            </div>
            <div className="single_details">
              <h2 className="fs_12 text_dark_gray">{t("Charged")}</h2>
              <h2 className="fs_14 text_black_3">
                {mySubscriptionDetails?.planId?.name}
              </h2>
            </div>
          </div>
        </div>
        <div className="common_card_2 mt-0">
          <h2 className="fs_20 text_black_2">{t("Update Your Plan")}</h2>
          <div className="row plans_section">
            {nonEnterpricePlan && (
              <div className="col-lg-6">
                <div
                  className={`standard_plan ${
                    nonEnterpricePlan?.id === activePlan?.id
                      ? "active"
                      : !nonEnterpricePlan?.id && activePlan?.isPopular
                      ? "active"
                      : ""
                  }`}
                >
                  <div className="btn-group" role="group">
                    {/* Conditionally render Monthly button */}
                    <button
                      type="button"
                      onClick={() => {
                        handleButtonClick(starterPlan);
                      }}
                      className={`plan_btn ${
                        billingCycle === "monthly" ? "active" : ""
                      }`}
                    >
                      {t("Monthly")}
                    </button>
                    <button
                      type="button"
                      className={`plan_btn ${
                        billingCycle === "yearly" ? "active" : ""
                      }`}
                      onClick={() => {
                        handleButtonClick(professionalPlan);
                      }}
                    >
                      {t("Annually")}
                    </button>
                  </div>

                  <div className="standard_div">
                    <img src={planStar} width={64} height={64} alt="" />
                    <h2 className="standard_text">{t("Standard")}</h2>
                  </div>

                  <div className="prices_section">
                    {nonEnterpricePlan?.discountInPercentage === 0 ? null : (
                      <h2>
                        <CurrencySymbol
                          color="#000000"
                          width="16"
                          height="18"
                        />
                        {getBasePrice(nonEnterpricePlan)}
                      </h2>
                    )}
                    <h3>
                      <CurrencySymbol color="#ffffff" width="24" height="26" />
                      {getMonthlyPrice(nonEnterpricePlan)}
                      <span>/month</span>
                    </h3>
                  </div>

                  <div className="one_time_fee_text">
                    <h4>
                      <CurrencySymbol color="#000000" width="18" height="18" />{" "}
                      {nonEnterpricePlan?.oneTimeSetupPrice}
                    </h4>
                    <p>{t(`Setup Fees with annual plans`)}</p>
                  </div>

                  <div>
                    <ul>
                      <h2 className="features_text">{t("Features")}</h2>
                      {nonEnterpricePlan?.features?.map((feature) => (
                        <li key={feature?._id}>
                          <img
                            src={checkWhite}
                            width={24}
                            height={24}
                            alt="icon"
                          />
                          {i18n.language === "en"
                            ? feature?.title
                            : feature?.titleAr}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="transactions_details">
                    <h5>{t("Transaction Fees:")}</h5>
                    <div className="tran_inner_div">
                      <div className="single_fee">
                        <img src={fee1} width={30} height={27} alt="" />
                        <span className="">1% +</span>
                        <span className="currency_symbol_wrapper ltr">
                          <CurrencySymbol color="#fff" width="12" height="12" />
                          1
                        </span>
                      </div>
                      <div className="single_fee">
                        <img src={fee2} width={30} height={27} alt="" />

                        <span className="">2.4% +</span>
                        <span className="currency_symbol_wrapper ltr">
                          <CurrencySymbol color="#fff" width="12" height="12" />
                          1
                        </span>
                      </div>
                      <div className="single_fee">
                        <img src={fee4} width={30} height={27} alt="" />

                        <span className="">3.4% +</span>
                        <span className="currency_symbol_wrapper ltr">
                          <CurrencySymbol color="#fff" width="12" height="12" />
                          1{" "}
                        </span>
                      </div>
                      <div className="single_fee">
                        <img src={fee4} width={30} height={27} alt="" />

                        <span>
                          Based card <br /> Payment
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {enterprisePlan && (
              <div className="col-lg-6">
                <div
                  className={`custom_plan ${
                    selectedPlan?.id === enterprisePlan?.id
                      ? "active"
                      : !selectedPlan?.id && enterprisePlan?.isPopular
                      ? "active"
                      : ""
                  }`}
                  onClick={() => {
                    setSelectedPlan(enterprisePlan);
                    setPlanType(enterprisePlan.name);
                    handleOpen();
                  }}
                >
                  <div>
                    <h2 className="name">
                      <img
                        src={customPlan}
                        width={64}
                        height={64}
                        alt="custom plan"
                        className="me-2"
                      />
                      {t("Custom Plan")}
                    </h2>
                    <h3>{t("Tailored for Your Business Needs")}</h3>
                    <p>
                      {t(
                        "Work with our experts to design a plan that perfectly fits your requirements."
                      )}
                    </p>
                    <button className="main_btn">
                      {t("Talk to an Expert to Design Your Perfect Plan")}
                    </button>
                    <ul>
                      <h4 className="feature_text">{t("Features")}</h4>
                      {enterprisePlan?.features?.map((feature) => (
                        <li key={feature?._id}>
                          <img
                            src={feature?.included ? checkGreen : circle}
                            width={24}
                            height={24}
                            alt="icon"
                          />
                          {i18n.language === "en"
                            ? feature?.title
                            : feature?.titleAr}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            )}
            {planType &&
              !mySubscriptionDetails?.cancelledInfo?.isCancelled &&
              planType !== "FREE_TRIAL" &&
              planType !== "Enterprise" &&
              selectedPlan && (
                <div className="col-lg-12">
                  <div className="sub_total_row">
                    <div className="g_between align-items-start mt-2">
                      <h2 className="fs_14 text_black_2">
                        {t("Yearly Price")}
                      </h2>
                      <div>
                        <h2 className="fs_16 text_black_2 ltr">
                          <CurrencySymbol width="12" height="14" />
                          {getYearlyPrice(selectedPlan)}
                        </h2>
                      </div>
                    </div>
                    <div className="g_between align-items-start mt-2">
                      <h2 className="fs_14 text_black_2">{t("Discount")}</h2>
                      <div>
                        <h2 className="fs_16 text_success ltr">
                          <CurrencySymbol width="12" height="14" />
                          {discountAmount.toFixed(2)}
                        </h2>
                      </div>
                    </div>
                    <div className="g_between align-items-start mt-2">
                      <h2 className="fs_14 text_black_2">
                        {t("Monthly Price")}
                      </h2>
                      <div>
                        <h2 className="fs_16 text_black_2 ltr">
                          <CurrencySymbol width="12" height="14" />
                          {getMonthlyPrice(selectedPlan)}
                        </h2>
                      </div>
                    </div>
                    <div className="g_between align-items-start mt-2">
                      <h2 className="fs_20 text_black_2">{t("Total")}</h2>
                      <div>
                        <h2 className="fs_20 text_black_2 text-end">
                          <CurrencySymbol width="15" height="17" />
                          <span className="text_primary_2">{totalAmount}</span>
                        </h2>
                        <button
                          className="main_btn d-block ms-auto continue_btn"
                          onClick={handleUpdatePlan}
                          disabled={isLoading || continueBtn}
                        >
                          {t("Continue")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        fullscreen
        className="plan_upgrade_modal"
      >
        <div className="inner_section">
          <div className="left_section">
            <img
              src={brandInfo?.theme?.logo}
              alt="ease"
              width={123}
              height={40}
            />
            <div
              className={`d-flex gap-1 align-items-start cursor-pointer my_planinfo_modal ${i18n.language}`}
            >
              <ChevronLeft onClick={handleClose} />
              <h2>
                {t("Manage ")}
                {t(brandInfo?.org?.subdomain)}
                {t(" Plan and billing")}
              </h2>
            </div>
          </div>
          <div className="right_section">
            <PlanUpgrade
              planType={planType}
              setPlanType={setPlanType}
              selectedPlan={selectedPlan}
              setSelectedPlan={setSelectedPlan}
              handleClose={handleClose}
            />
          </div>
        </div>
      </Modal>
      <Modal
        show={show2}
        onHide={handleHideModal2}
        centered
        className="common_modal w_408 cancel_sub_modal"
      >
        <img
          src={isCancelled ? tick : circle}
          alt="circle"
          width={50}
          height={50}
        />
        <h2 className="fs_20 mt_20">
          {isCancelled
            ? "Subscription cancelled successfully!"
            : "Cancel Subscription?"}
        </h2>
        <p className="fs_14 text_dark_gray_2 mt_15">
          {isCancelled
            ? `Your subscription has been successfully cancelled. You will continue to have access until the end of your current billing period on ${formatDate(
                mySubscriptionDetails?.billingCycleEnd
              )}`
            : `Your current plan will remain active until ${formatDate(
                mySubscriptionDetails?.billingCycleEnd
              )}. Are you sure you want to cancel?`}
        </p>
        <div className="mt_30"></div>
        {!isCancelled && (
          <button className="main_btn" onClick={handleCancelSubscription}>
            Confirm Cancellation
          </button>
        )}
        <button className="cancel_btn mt_10" onClick={handleHideModal2}>
          Cancel
        </button>
      </Modal>
    </div>
  );
}

export default MyPlanInfo;
